<!--
 * @Description: 指数比较
 * @Author: aihh
 * @Date: 2019-09-04
 * @LastEditTime: 2019-09-04
 * @LastEditors: aihh
 -->
 <template>
   <div class="box">
     <ul class="tab-header">
       <li>Shares</li>
       <li>Latest point</li>
       <li>Turnover</li>
     </ul>
     <div style="flex: 1;overflow-y: auto;width: 100%" class="innerbox scroll_bar_wzj">
       <ul v-for="(item,index) in sortData" :key="item.name" style="line-height:32px" @click="getCodeInfo(item,index)">
 <!--        {{item}}-->
         <li>{{item["prod_name"]}}</li>
         <!-- 最新价 -->
         <li v-if="item.px_change===0">
           <span
            v-if="item.last_px"
            :class="[
             {'bg-red':item.last_px_wzjChange==1},
             {'bg-green':item.last_px_wzjChange==2},
             {'bg-none':item.last_px_wzjChange==0}
            ]"
           >
             {{item["last_px"].toFixed(getToFixed(prod_code,'price'))}}
           </span>
           <span v-else>
             --
           </span>
         </li>
         <li v-else :style="{color:item.px_change>0?'#EF4342':'#2AB447'}">
           <span :class="[
             {'bg-red':item.last_px_wzjChange==1},
             {'bg-green':item.last_px_wzjChange==2},
             {'bg-none':item.last_px_wzjChange==0}
            ]">
             {{item["last_px"].toFixed(getToFixed(prod_code,'price'))}}
           </span>
         </li>
         <!-- 涨跌幅 -->
        <li v-if="item.px_change===0">
           <span
             v-if="item.last_px"
             :class="[
             {'bg-red':item.px_change_rate_wzjChange==1},
             {'bg-green':item.px_change_rate_wzjChange==2},
             {'bg-none':item.px_change_rate_wzjChange==0}
            ]">
             {{item["px_change_rate"].toFixed(getToFixed(prod_code,'price'))}}%
           </span>
           <span v-else>
             --
           </span>
         </li>
         <li v-else :style="{color:item.px_change>0?'#EF4342':'#2AB447'}">
           <span :class="[
             {'bg-red':item.px_change_rate_wzjChange==1},
             {'bg-green':item.px_change_rate_wzjChange==2},
             {'bg-none':item.px_change_rate_wzjChange==0}
            ]">
<!--             {{item["px_change_rate"]>0?'':'-'}} -->
             {{item["px_change_rate"].toFixed(2)}}%
           </span>
         </li>

 <!--        <li v-if="item[5]===0">{{item[3]}}</li>-->
 <!--        <li v-else :style="{color:item[5]<0?'#2AB447':'#EF4342'}">{{item[3].toFixed(2)}}</li>-->
 <!--        <li v-if="item[5]===0">{{item[5].toFixed(2)}}%</li>-->
 <!--        <li v-else :style="{color:item[5]<0?'#2AB447':'#EF4342'}">{{item[5]<0?'-':''}}{{Math.abs(item[4]).toFixed(2)}}%</li>-->
       </ul>
     </div>
     <div style="height: 1px;"></div>
   </div>
 </template>

<script>

import { checkExchange,getToFixed } from '../../controller/util'
import { OpenAPI } from '../../controller/datamanager/api.js'
export default {
  name: 'indexCompare',
  props: {
    throttle: {
      type: Number,
      default: 3000,
    }
  },
  data() {
    return {
      // 定时器
      timer: null,
      sortData: [],
      getToFixed:getToFixed,
      // prod_code: '000001.SS,399001.SZ,000300.SS,399006.SZ,000016.SS,000010.SS,000009.SS,000002.SS,000003.SS,399002.SZ,399106.SZ,399004.SZ,399003.SZ,399005.SZ,399673.SZ,399678.SZ,000004.SS,000005.SS,000006.SS,000043.SS',
      // 1120依客户要求调整
      // 上证指数  000001.SS,深证成指  399001.SZ,沪深300  000300.SS,创业板指  399006.SZ,上证50  000016.SS,上证180  000010.SS,上证380  000009.SS,中证800  000906.SS,深成指R  399002.SZ,深证综指  399106.SZ,深证100R  399004.SZ,中小板指  399005.SZ,工业指数  000004.SS,商业指数  000005.SS,地产指数  000006.SS
      prod_code: '000001.SS,399001.SZ,000300.SS,399006.SZ,000016.SS,000010.SS,000009.SS,000906.SS,399002.SZ,399106.SZ,399004.SZ,399005.SZ,000004.SS,000005.SS,000006.SS'
    }
  },
  created() {
    this.getIndexDataInterval(this.prod_code, 'prod_name,last_px,px_change_rate,px_change,px_change,preclose_px')
    // 轮询
       if(this.throttle > 0){
         this.timer = setInterval(()=>{
              this.getIndexDataInterval(this.prod_code, 'prod_name,last_px,px_change_rate,px_change,preclose_px')
         },10000)
       }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
      getCodeInfo(value,code){
          const obj={
              code:value.prod_code,name:value.prod_name
          }
          this.$emit('clickProd',obj)
      },
    getIndexDataInterval(code, fields){
      let params = {code, fields}
      OpenAPI.real(params).then(res => {
        console.log(res,'OpenAPI.real')
        if(res.fields){
          let ss = res;
          let fields = ss.fields;
          let showData = [];
          for (let a in ss) {
            if ("fields" === a) {
              continue;
            }
          var tmp = {};
          // 代码
          tmp["prod_code"] = a
          // 名称
          tmp["prod_name"] = ss[a][fields.indexOf("prod_ name")];
          // 最新价
          tmp["last_px"] = ss[a][fields.indexOf("last_px")];
          // 涨跌幅
          tmp["px_change_rate"] = ss[a][fields.indexOf("px_change_rate")];
          // 涨跌额
          tmp["px_change"] = ss[a][fields.indexOf("px_change")];
          showData.push(tmp);
          }
          console.log(showData,'showData-showData');
          // 添加背景颜色
          showData.forEach( newVal => {
          	this.sortData.forEach(oldVal => {
          		if(newVal.prod_name === oldVal.prod_name){
          			 for(let key in newVal) {
                  // 变化项处理
                  if(typeof newVal[key] === 'number'){
                  	if(newVal[key] > oldVal[key]){
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 1
                  	}else if(newVal[key] < oldVal[key]){
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 2
                  	}else{
                      let newKey = `${key}_wzjChange`
                      newVal[newKey] = 0
                  	}
                  }
          			 }
          		}
          	})
          })
          // console.log(this.sortData)
          this.sortData = showData
        }
        }).catch(err => {
          // return alert('请检查成分股代码格式！')
          console.log('请检查成分股代码格式！')
        })

    }
  },
}
</script>


<style scoped>
*{
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style-type: none;
  text-align: center;
  box-sizing: border-box;
}
.bg-red {
  /* background: #F9D9E4; */
  background: rgb(255,253,215);
}
.bg-green {
  /* background: #D3F5D4; */
  background: rgb(255,253,215);
}
.tab-header{
  height: 40px;
  color: #399BFF;
  width: 98%;
  margin-right: 6px;
}
.box{
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.innerbox ul>li:nth-child(1) {
  cursor: pointer;
}
.innerbox ul:hover {
  background: #E4EDF3;
}
.innerbox ul:hover li span{
  background: #E4EDF3;
}
.innerbox::-webkit-scrollbar {width: 6px; -ms-overflow-style: none;}
.innerbox::-webkit-scrollbar-thumb {border-radius: 4px;-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);background: rgba(193,193,193,193);}
.innerbox::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}
.scroll_bar_wzj {
    height: 100%;
    overflow-y: auto;
    box-sizing: content-box;
    margin-right: -10px;
    padding-right: 10px;
}
li:nth-child(2) span{
   margin-right: -7px;
}
li:nth-child(3) span{ 
  margin-right: -10px;
}
.scroll_bar_wzj:after {
  content: "";
  height: 16px;
  display: block;
}
ul{
  padding: 0 15px;
  min-height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: #333;
}
ul li{
    text-align: right;
}
ul li span {
  display: inline-block;
  text-align: right;
  width: 65px;
  line-height: 24px;
}
ul li:nth-child(1){ 
  text-align: left;
   width: 30%;
}
ul li:nth-child(2){ 
  width: 31%;
}
ul li:nth-child(3){ 
   width: 39%;
}
</style>
